export const ROUTES = {
	TRANSACTIONS: 'transactions',
	PROMOTIONS: 'promotions',
	REDEMPTIONS: 'redemptions'
}

export const QUERY_PARAMS = {
	TAB: 'tab'
}
